import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ivory text-charcoal text-center px-6">
          <div>
            <p className="font-display text-3xl">Something came unwrapped…</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 rounded-full bg-crimson text-ivory px-8 py-3 text-sm font-semibold"
              data-testid="error-reload-button"
            >
              Reload the page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
